import 'imports-loader?this=>window,fix=>module.exports=0,define=>false,exports=>false!parsleyjs/dist/parsley';
import 'imports-loader?this=>window,fix=>module.exports=0,define=>false,exports=>false!parsleyjs/dist/i18n/en';
import 'imports-loader?this=>window,fix=>module.exports=0,define=>false,exports=>false!parsleyjs/dist/i18n/en.extra';
import 'imports-loader?this=>window,fix=>module.exports=0,define=>false,exports=>false!parsleyjs/dist/i18n/ru';
import 'imports-loader?this=>window,fix=>module.exports=0,define=>false,exports=>false!parsleyjs/dist/i18n/ru.extra';

export { eachOfForm };

function eachOfForm(index, Form) {
    const $form = $(Form);

    if ($form.data('pearsley-init')) {
        return true;
    }

    $form.data('pearsley-init', true);
    let lang = $('html').attr('lang');
    lang = lang != 'ru' && lang != 'en' ? 'en' : lang;

    Parsley.setLocale(lang); // чтобы от языка показывались правильные сообщения

    const validator = $form.parsley({
        excluded: $form.data('parsley-excluded') || 'input[type=button], input[type=submit], input[type=reset], input[type=hidden], [disabled], :hidden, [data-parsley-disabled], [data-parsley-disabled] *'
    });

    $form.data({ validator }).on('change', function onFormChange(evt) {
        const Input = validator.fields.filter((Field) => evt.target === Field.element)[0];

        if (Input) {
            Input.validate();
        }

        validator.refresh();
    });
}



// WEBPACK FOOTER //
// ./js/main/module/form-validation/module.js